import { round } from 'lodash-es';
export function getPercentageValue(value, total) {
    if (total === 0) {
        return 0;
    }
    return round((value * 100) / total, 2);
}
